import React, { useEffect, useState } from 'react';

import {
  StripeAccountLinkRequest,
  StripeConnectedAccountInfo,
} from '@flipdish/api-client-typescript';
import { Button } from '@flipdish/ui-library/components/atoms/Button';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { type RouteComponentProps, withRouter } from 'react-router';
import { compose } from 'recompose';

import { usePrevious } from '../../../../../../custom-hooks/usePrevious';
import YesNoDialog from '../../../../../../ui/Dialog/YesNoDialog';
import { createStripeConnectedAccountLink } from '../../../banking.actions';

type OuterProps = {
  bankAccountId?: number;
  stripeAccount: StripeConnectedAccountInfo;
};

type MappedState = ReturnType<typeof mapStateToProps>;
type MappedDispatch = ReturnType<typeof mapDispatchToProps>;
type Props = OuterProps & MappedState & MappedDispatch & RouteComponentProps;

const StripeDetailsButton = (props: Props) => {
  const { stripeAccount, setAccountLink, stripeUrl, bankAccountId, location, history } = props;

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const previousUrl = usePrevious(stripeUrl);

  useEffect(() => {
    if (previousUrl !== stripeUrl && stripeUrl !== '') {
      window.location.href = (stripeUrl as any).Url || stripeUrl;
    }
  }, [stripeUrl]);

  const getReturnUrl = () => {
    const currentWindow = window.location.href;
    return bankAccountId
      ? currentWindow.replace('/bank-accounts/new', `/bank-accounts/${bankAccountId}`)
      : currentWindow;
  };

  const handleConfirm = () => {
    if (bankAccountId) {
      history.push(
        location.pathname.replace('/bank-accounts/new', `/bank-accounts/${bankAccountId}`)
      );
    } else {
      history.push(location.pathname);
    }

    const stripeAccountLinkRequest = {
      Collect: StripeAccountLinkRequest.CollectEnum.EventuallyDue,
      ReturnUrl: getReturnUrl(),
      StripeId: stripeAccount.StripeId,
      Type: StripeAccountLinkRequest.TypeEnum.Onboarding,
    } as StripeAccountLinkRequest;

    setAccountLink(stripeAccountLinkRequest);
    setIsDialogOpen(false);
  };

  return (
    <>
      <Button
        color="secondary"
        size="md"
        onPress={() => setIsDialogOpen(true)}
        className="w-full sm:w-auto"
      >
        <Translate id="Edit_Account_Details" />
      </Button>

      <YesNoDialog
        open={isDialogOpen}
        titleTextId="Edit_Account_Details"
        yesTextId="Continue_to_Stripe"
        noTextId="Cancel"
        onYes={handleConfirm}
        onNo={() => setIsDialogOpen(false)}
      >
        <Translate id="Updating_your_Stripe_details" />
      </YesNoDialog>
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  stripeUrl: state.banking.stripeLinkUrl,
});

function mapDispatchToProps(dispatch: ThunkDispatch) {
  return {
    setAccountLink: (stripeAccountLinkRequest: StripeAccountLinkRequest) => {
      dispatch(createStripeConnectedAccountLink(stripeAccountLinkRequest));
    },
  };
}

export default compose<MappedState & MappedDispatch & RouteComponentProps, OuterProps>(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(StripeDetailsButton);
